// removed by extract-text-webpack-plugin
module.exports = {"nothing":"_3yLe-a_gHwZZbasDsy94zl","item":"LhVF35U8OdjcnEC0WjYfH","unread":"t7z8iDKdAeyiqRfA2X-fs","text":"_1kLkA5lw8DT_VnIfE0o0mO","items":"_2K70vqvTBaglEEYi2EbYPm","boxNotification":"_11YQH97dHuoDfXwf93s4Bz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/organisms/UserNotifications/style.css
// module id = 276
// module chunks = 42